import { getAClByEmail, getAllACL, saveAcl } from "./acl";
import { searchMasterListPage } from "./master_list";
import {
    addCaseloadBooking,
    cancelOwnConfirmedAppointment,
    confirmAppointment,
    deleteAppoinment,
    deleteConfirmedAppointmentFromClinician,
    deleteReservedAppointment,
    fetchReservedAppointments,
    holdAppointment,
    reserveAppointment,
    updateBooking,
    moveConfirmedAppointmentToHeld,
} from "./appointment";
import {
    deleteHistory,
    fetchArchivedClientsByEmails,
    mergeClientFromArchive,
    getClientHistoryById,
    searchMasterList,
    updateArchivedClient,
    updateArchivedClientCompletionReason,
} from "./archive";
import {
    deleteClient,
    fetchAllClientsByStatus,
    fetchAllClientsData,
    fetchClientsByEmails,
    fetchClientsByIds,
    findClientsByField,
    getAllAssignedClientsByEmail,
    findClientsByFirstAndLastName,
    getClientById,
    saveClientData,
    updateClientData,
    updateHeldAppointmentConsentCheck,
} from "./client";
import {
    addClinicianAvailability,
    addClinicianOfficeWindow,
    deleteClinician,
    doesClinicianExist,
    fetchAllCliniciansByLocation,
    fetchAllCliniciansData,
    fetchAllCliniciansIdentifier,
    fetchAllSupervisors,
    fetchSupervisees,
    fetchCliniciansByIds,
    fetchClinicianStatusChanges,
    findClinicianByField,
    getClinicianByEmail,
    saveClinicianData,
    searchClincians,
    updateClinicianAndClientDocuments,
    updateClinicianAvailability,
    updateClinicianData,
    updateClinicianExperienceLevels,
    updateClinicianOfficeWindows,
    removeClinicianOfficeWindowAndAvailability,
    updateAvailabilitySchedule,
    updateIntakeSessionBooking,
    replaceIntakeSessionBooking,
    updateIntakeSessionStatusByBooking,
    removeIntakeSessionFromSupervisor,
} from "./clinician";
import {
    createClinicianOfficeWindowRequests,
    deleteOfficeWindowRequests,
    approveClinicianOfficeWindow,
    findOfficeWindowRequestsByClinicianEmail,
    findOfficeWindowRequestsByIds,
    findOfficeWindowRequestsByCategory,
    findClinicianOfficeWindowRequestsByCategory,
    rejectClinicianOfficeWindow,
    retrieveOfficeManagerActivities,
    createAvailableOfficeWindows,
    getOfficeWindows,
    getPotentialCoveringOfficeWindows,
    deleteOfficeWindowById,
    blockOrUnblockOfficeWindowById,
    handleHoldOfficeSpace,
    getAllHeldOfficeWindowsByLocation,
    getUnPaginatedOfficeWndows,
} from "./officeWindow";
import {
    addEmailReminder,
    deleteOutboundEmail,
    fetchOutboundEmails,
    queueConsentEmail,
    queueConsentReminderEmail,
    queueEmail,
    updateOutboundEmailStatus,
} from "./email";
import {
    addNewExperienceLevel,
    getAllExperienceLevels,
    deleteExperienceLevels,
    getExperienceLevelAcrossClinicians,
} from "./experience_level";
import {
    getAllMethodologyOptions,
    addMethodologyOption,
    deleteMethodologyOption,
} from "./methodology";
import { getReportData } from "./report";
import { getStats } from "./stats";
import {
    updateClinicianServiceSelection,
    fetchAllCliniciansServiceSelection,
    fetchClinicianServiceSelection,
    mapServicesToADepartment,
    fetchDepartmentAndServices,
    deleteServiceFromDepartment,
} from "./department";
import { fetchOutboundSms, queueSms } from "./sms";
import {
    getCommunicationSummary,
    updateCommunicationSummary,
} from "./communication";

const storeFunctions = {
    addCaseloadBooking,
    cancelOwnConfirmedAppointment,
    addClinicianAvailability,
    addClinicianOfficeWindow,
    addEmailReminder,
    addNewExperienceLevel,
    confirmAppointment,
    deleteAppoinment,
    deleteClient,
    deleteClinician,
    deleteConfirmedAppointmentFromClinician,
    deleteHistory,
    deleteOutboundEmail,
    deleteReservedAppointment,
    doesClinicianExist,
    fetchAllClientsByStatus,
    fetchAllClientsData,
    fetchAllCliniciansByLocation,
    fetchAllCliniciansData,
    fetchAllSupervisors,
    fetchArchivedClientsByEmails,
    mergeClientFromArchive,
    fetchClientsByEmails,
    fetchAllCliniciansIdentifier,
    fetchClientsByIds,
    fetchAllCliniciansServiceSelection,
    fetchClinicianServiceSelection,
    fetchDepartmentAndServices,
    deleteServiceFromDepartment,
    mapServicesToADepartment,
    fetchCliniciansByIds,
    fetchClinicianStatusChanges,
    fetchOutboundEmails,
    fetchSupervisees,
    fetchReservedAppointments,
    findClientsByField,
    getAllAssignedClientsByEmail,
    findClientsByFirstAndLastName,
    findClinicianByField,
    getAClByEmail,
    getAllACL,
    getAllExperienceLevels,
    deleteExperienceLevels,
    getClientById,
    getClientHistoryById,
    getClinicianByEmail,
    getExperienceLevelAcrossClinicians,
    getReportData,
    holdAppointment,
    getStats,
    queueConsentEmail,
    queueEmail,
    queueConsentReminderEmail,
    queueSms,
    fetchOutboundSms,
    getCommunicationSummary,
    updateCommunicationSummary,
    createAvailableOfficeWindows,
    reserveAppointment,
    saveAcl,
    saveClientData,
    saveClinicianData,
    getOfficeWindows,
    getPotentialCoveringOfficeWindows,
    searchClincians,
    updateClinicianAndClientDocuments,
    searchMasterList,
    updateBooking,
    searchMasterListPage,
    updateClientData,
    updateHeldAppointmentConsentCheck,
    updateClinicianAvailability,
    updateClinicianData,
    blockOrUnblockOfficeWindowById,
    getAllHeldOfficeWindowsByLocation,
    getUnPaginatedOfficeWndows,
    handleHoldOfficeSpace,
    createClinicianOfficeWindowRequests,
    deleteOfficeWindowRequests,
    approveClinicianOfficeWindow,
    rejectClinicianOfficeWindow,
    findOfficeWindowRequestsByClinicianEmail,
    findOfficeWindowRequestsByIds,
    findOfficeWindowRequestsByCategory,
    findClinicianOfficeWindowRequestsByCategory,
    updateClinicianExperienceLevels,
    updateClinicianOfficeWindows,
    removeClinicianOfficeWindowAndAvailability,
    updateOutboundEmailStatus,
    updateArchivedClient,
    updateArchivedClientCompletionReason,
    deleteOfficeWindowById,
    updateClinicianServiceSelection,
    moveConfirmedAppointmentToHeld,
    updateAvailabilitySchedule,
    updateIntakeSessionBooking,
    replaceIntakeSessionBooking,
    updateIntakeSessionStatusByBooking,
    retrieveOfficeManagerActivities,
    removeIntakeSessionFromSupervisor,
    getAllMethodologyOptions,
    addMethodologyOption,
    deleteMethodologyOption,
};

export default storeFunctions;
